import { isUserFromWebView } from './webviewComunication';

export type AppName = 'cp-webapp' | 'cp-mobile-app' | 'ac-app' | 'ac-mobile-app';

/**
 * Fonte da verdade única do appName da superfície de acesso do cliente.
 *
 * Combina a brand (VITE_ACP_APP_NAME / window.__ACP_APP_NAME__) com a
 * detecção de app nativo (isUserFromWebView para v5.x-, window.isNativeApp
 * para v6.x+). É self-contained de propósito — pode ser usado por qualquer
 * app e por qualquer lib sem dependência circular.
 *
 * | Brand | Nativo          | Web        |
 * |-------|-----------------|------------|
 * | cp    | cp-mobile-app   | cp-webapp  |
 * | ac    | ac-mobile-app   | ac-app     |
 *
 * Espelha a resolução de brand de `getAcpAppName` (libs/acp) — a lógica é
 * duplicada de propósito para evitar ciclo utils→acp no grafo Nx. Se a
 * resolução de brand mudar aqui, mantenha os dois em sincronia.
 */
export function getAppName(): AppName {
  const brand =
    import.meta.env.VITE_ACP_APP_NAME ||
    (window as Window & { __ACP_APP_NAME__?: string }).__ACP_APP_NAME__;

  if (!brand) {
    console.warn(
      '[utils] getAppName: VITE_ACP_APP_NAME e window.__ACP_APP_NAME__ ausentes. Usando fallback "ac" — requisições do CP seriam rotuladas como AC no X-App-Id.',
    );
  }

  const isNativeApp = isUserFromWebView() || window.isNativeApp;

  if (isNativeApp) {
    return brand === 'cp' ? 'cp-mobile-app' : 'ac-mobile-app';
  }

  return brand === 'cp' ? 'cp-webapp' : 'ac-app';
}
